import "../layout"

// custom library
import Choices from 'choices.js'

function choicesJs() {
    const element = document.querySelector('#blog-sort')

    if (element) {
        const choices = new Choices(element, {
            searchEnabled: false,
            itemSelectText: ' ',
            allowHTML: true,
            shouldSort: false,
        });
    }
}

function sortingBlog() {
    const formElement = document.querySelector('#sorting-form')

    const selectElement = document.querySelector('#blog-sort')

    if (selectElement) {
        selectElement.addEventListener('change', (item) => {
            formElement.submit()
        })
    }
}

document.addEventListener('DOMContentLoaded', () => {
    choicesJs()
    sortingBlog()
})